<template>
  <div class="point-editor">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="point-editor__content">
      <b-form>
        <slot name="floor"></slot>
        <b-form-group label="Name" :state="!!$v.areaTemp.title.$model">
          <b-input type="text" placeholder="Name" v-model="$v.areaTemp.title.$model" />
        </b-form-group>
        <b-form-group label="Color" :state="!!$v.areaTemp.color.$model">
          <b-input type="color" v-model="$v.areaTemp.color.$model" />
        </b-form-group>
        <div class="btn-panel">
          <b-btn type="button" variant="default" @click="destroy" title="Delete" v-if="can(PN.PRINTER_DELETE) && !isNew" class="mr-auto">
            <i class="ion ion-md-trash"></i
          ></b-btn>
          <div class="ml-auto"></div>
          <b-btn type="button" variant="primary" @click="save">Save</b-btn>
          <b-btn type="button" variant="default" class="ml-2" @click="cancel">Cancel</b-btn>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { isLocalId } from '@/utils/Id'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { POINT_UPDATE } from '@/store/modules/point'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import { getItemHeader } from '@/components/shared/helpers'
import { cloneDeep } from 'lodash'

export default {
  name: 'AreaEditor',
  components: { AppMapPointPanelHeader },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    point: {
      type: Object
    }
  },
  validations() {
    return {
      areaTemp: {
        title: {},
        color: {}
      }
    }
  },
  data: () => ({
    PN,
    coordinates: [],
    areaTemp: {
      color: '',
      title: ''
    }
  }),
  computed: {
    ...mapGetters('point', ['getPoint']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Area')
    },
    isNew() {
      return isLocalId(this.areaTemp.id)
    }
  },
  methods: {
    ...mapMutations('point', {
      pointUpdate: POINT_UPDATE
    }),
    ...mapActions('point', ['pointSave']),
    save() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.pointSave(Object.assign(this.areaTemp, { floor_id: this.point.floor_id })).then((pointId) => {
          this.$emit('save', { pointId })
        })
      }
    },
    cancel() {
      this.pointUpdate({ id: this.point.id, coordinates: this.coordinates })
      this.$emit('cancel')
    },
    destroy() {
      this.$appToast.question('A you sure want to delete area?').then(() => {
        this.$emit('destroy')
      })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(id) {
        const { color, title, coordinates } = this.getPoint(id)
        this.coordinates = cloneDeep(coordinates)
        this.areaTemp = {
          id,
          color,
          title
        }
      }
    }
  }
}
</script>

<style lang="scss">
.point-editor__content {
  padding: 24px;
}

.select-item {
  display: flex;
  justify-items: left;

  .btn {
    margin-left: auto;
  }
}
</style>
